/* Wood Store hero slider. One block per slide, per-slide duration.
   Pauses on hover, on focus, and when the tab is hidden.
   Honours prefers-reduced-motion by not auto-rotating at all. */
(function () {
  function init(root) {
    if (root.getAttribute('data-ws-hs-ready') === '1') return;
    root.setAttribute('data-ws-hs-ready', '1');

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ws-hs-slide]'));
    if (slides.length < 2) return;

    var track = root.querySelector('[data-ws-hs-track]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('.ws-hs__dot'));
    var i = 0;
    var timer = null;
    var paused = false;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var auto = root.getAttribute('data-autoplay') === 'true' && !reduce;

    function schedule() {
      clearTimeout(timer);
      if (!auto || paused) return;
      var secs = parseInt(slides[i].getAttribute('data-duration'), 10) || 6;
      timer = setTimeout(function () { go(i + 1); }, secs * 1000);
    }

    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      slides.forEach(function (s, k) {
        s.classList.toggle('is-active', k === i);
        if (k === i) s.removeAttribute('aria-hidden');
        else s.setAttribute('aria-hidden', 'true');
      });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
        if (k === i) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
      schedule();
    }

    function pause() { paused = true; clearTimeout(timer); }
    function resume() { paused = false; schedule(); }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        go(parseInt(d.getAttribute('data-i'), 10));
      });
    });

    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', resume);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', resume);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pause(); else resume();
    });

    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? i + 1 : i - 1);
      x0 = null; y0 = null;
    }, { passive: true });

    schedule();
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-ws-hs]');
    for (var k = 0; k < nodes.length; k++) init(nodes[k]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
